import agent from '../agent';
import { FETCH_PAGE_STARTED, FETCH_PAGE_FINISHED } from '../constants/actionTypes';

export const fetchPageStart = () => {
  return {
    type: FETCH_PAGE_STARTED
  }
}

export const fetchPageFinished = (payload) => {
  return {
    type: FETCH_PAGE_FINISHED,
    payload
  }
}

export const fetchPage = (urlSlug) => (dispatch) => {
  dispatch(fetchPageStart());
  agent.Pollies.getByURLSlug(urlSlug).then(res=>{
    dispatch(fetchPageFinished(res));
  }, err=> {
    dispatch(fetchPageFinished(err));
  })  
}

export const clearPage = () => (dispatch) => {
  dispatch(fetchPageStart());
}
